import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e25610aa")

_pushScopeId("data-v-e25610aa")
const _hoisted_1 = { class: "admin-form" }
const _hoisted_2 = { class: "big-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "apply" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "適用", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", null, _toDisplayString(_ctx.bigTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("label", null, _toDisplayString(_ctx.header1), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("textarea", {
        value: _ctx.referenceText,
        disabled: true
      }, null, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("label", null, _toDisplayString(_ctx.header2), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("textarea", {
        value: _ctx.inputText,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.emit('update:inputText', $event.target.value)))
      }, null, 40, ["value"])
    ]),
    _createVNode(_component_ErrorMessage, {
      class: "value",
      messages: _ctx.errorMessages
    }, null, 8, ["messages"]),
    _createVNode("div", _hoisted_7, [
      _createVNode("p", null, _toDisplayString(_ctx.info), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.emit('update')))
      }, [
        _hoisted_9
      ])
    ])
  ]))
})